import { formatCurrency, generateCountryCode, getRandomFloat } from '../utils/randomizer'

export const marketEstimationRoutes = {
  'GET /market-estimation/total/app/:trackId': (params, _config) => {
    if (!params.trackId)
      throw new Error('Missing trackId')

    return {
      success: true,
      data: {
        download: getRandomFloat(1000, 10_000_000, 0),
        revenue: formatCurrency(getRandomFloat(0, 500_000, 2)),
      },
    }
  },
  'GET /market-estimation/audience-geography/:trackId': (params, _config) => {
    if (!params.trackId)
      throw new Error('Missing trackId')

    return {
      success: true,
      data: {
        status: 'OK',
        ratingNumberPerCountry: Array.from({ length: 10 }, () => ({
          countryCode: generateCountryCode(),
          ratio: getRandomFloat(0, 1, 3),
        })).sort((a, b) => b.ratio - a.ratio),
      },
    }
  },
}
